import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "info-container container-wrapper"
};
const _hoisted_2 = {
  class: "flex-row-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "title-tip"
  }, "为了保障您顺利参赛，请如实填写个人信息", -1)), _createVNode(_component_el_form, {
    ref: "formRef",
    model: $data.formData,
    rules: $data.rules,
    "label-width": "140px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      prop: "userPhone",
      label: "手机号:"
    }, {
      default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString($data.formData.userPhone), 1)]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      prop: "userName",
      label: "姓名:"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        class: "width-200",
        maxlength: "20",
        modelValue: $data.formData.userName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formData.userName = $event),
        "show-word-limit": "",
        onInput: _cache[1] || (_cache[1] = $event => $data.formData.userName = $data.formData.userName.replace(/ /g, ''))
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      prop: "schoolId",
      label: "所属院校:"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        class: "width-200",
        modelValue: $data.formData.schoolId,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formData.schoolId = $event),
        filterable: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.schoolList, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.schoolName,
            value: item.id
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      prop: "userPosition",
      label: "职务:"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        class: "width-200",
        maxlength: "20",
        modelValue: $data.formData.userPosition,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formData.userPosition = $event),
        "show-word-limit": ""
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
    type: "primary",
    class: "common-button-confirm",
    onClick: $options.submit
  }, {
    default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("提交")])),
    _: 1
  }, 8, ["onClick"])])]);
}